import { ADD_FAQ_REQUEST, DELETE_FAQ_REQUEST, EDIT_FAQ_REQUEST, FETCH_FAQ_REQUEST } from "./constants";
import { combineReducers } from "redux";
import { Action, FaqState } from "./types";
import { getFailureActionType, getSuccessActionType } from "../utils";

function item(state: FaqState = { currentPage: 0, pageCount: 1, data: [] }, action: Action): FaqState {
  let selected = null;
  switch (action.type) {
    case getSuccessActionType(FETCH_FAQ_REQUEST):
      return action.payload;

    case getSuccessActionType(ADD_FAQ_REQUEST):
      return { ...state, data: [...state.data, action.payload] };

    case getSuccessActionType(EDIT_FAQ_REQUEST):
      return {
        ...state,
        data: state.data.map((faq) =>
          faq.id === action.data ? { ...action.payload, isFetching: false } : faq
        ),
      };

    case getSuccessActionType(DELETE_FAQ_REQUEST): {
      selected = state.data?.filter((faq) => faq.id !== action.data);
      return { ...state, data: selected };
    }
    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_FAQ_REQUEST:
    case ADD_FAQ_REQUEST:
    case EDIT_FAQ_REQUEST:
      return true;

    case getSuccessActionType(FETCH_FAQ_REQUEST):
    case getFailureActionType(FETCH_FAQ_REQUEST):
    case getSuccessActionType(ADD_FAQ_REQUEST):
    case getFailureActionType(ADD_FAQ_REQUEST):
    case getSuccessActionType(EDIT_FAQ_REQUEST):
    case getFailureActionType(EDIT_FAQ_REQUEST):
      return false;

    default:
      return state;
  }
}

export const faq = combineReducers({ item, isFetching });
